import { Fragment, useState } from 'react';

import { RegisterInvoiceService as Service } from '../../../service/invoice/RegisterInvoiceService';

import { useToolbar } from '../../../shared/hooks/Toolbar';
import { useDataTable } from '../../../shared/hooks/DataTable';

import { View } from './View';
import { useTranslation } from '../../../shared/language';

export const List = () => {

  const { t } = useTranslation();

  const header = t('common.invoiceTemplate');
  const dataKey = 'id';

  const [displayPreview, setDisplayPreview] = useState(false);
  const [htmlPreview, setHtmlPreview] = useState(null);

  const { render: renderDataTable, reloadLazyData, selectedItems } = useDataTable({
    header,
    dataKey,
    columns: [
      { field: 'invoiceTypeName', header: t('common.invoiceType'), minWidth: 160, matchMode: 'contains' },
      { field: 'symbolCode', header: t('common.symbol'), width: 160, matchMode: 'contains' },
      { field: 'numberRecord', header: t('common.templatePrintRows'), width: 180, matchMode: 'equals', filterType: 'number', dataType: 'number' },
      { field: 'creatorName', header: t('common.creator'), width: 160, matchMode: 'contains' },
      { field: 'creationTime', header: t('common.createdDate'), width: 160, matchMode: 'equals', filterType: 'date', dataType: 'date' },
      { field: 'use', header: t('common.active'), width: 100, matchMode: 'equals', filterType: 'boolean', dataType: 'boolean' }
    ],
    indexColumnWidth: 40,
    getList: (params) => {
      return Service.getList(params);
    }
  });

  const { renderToolbar } = useToolbar({
    dataKey,
    create: () => {
      window.location.hash = '/phat-hanh/mau-hoa-don/create';
    },
    update: (item: any) => {
      window.location.hash = '/phat-hanh/mau-hoa-don/update/' + item[dataKey];
    },
    reloadLazyData,
    selectedItems,
    deleteItem: (id) => {
      return Service.delete(id);
    },
    otherActions: [
      {
        label: t('common.viewInvoiceTemplate'), icon: 'pi pi-fw pi-eye', className: 'iam-toolbar iam-toolbar-help', command: () => {
          if (selectedItems && selectedItems[dataKey]) {
            Service.get(selectedItems[dataKey]).then(data => {
              if (data && data.fileContent) {
                setHtmlPreview(data.fileContent);
                setDisplayPreview(true);
              }
            });
          }
        }
      },
      {
        label: t('common.copyInvoiceTemplate'), icon: 'pi pi-fw pi-copy', className: 'iam-toolbar iam-toolbar-help', command: () => {
          if (selectedItems && selectedItems[dataKey]) {
            window.location.hash = '/phat-hanh/mau-hoa-don/update/' + selectedItems[dataKey] + '?copy=Y';
          }
        }
      }
    ]
  });

  return (
    <Fragment>
      {renderToolbar()}
      {renderDataTable()}
      <View display={displayPreview} setDisplay={setDisplayPreview} html={htmlPreview} />
    </Fragment>
  )
}
